module.exports = __webpack_public_path__ + "static/img/bcg.979089a4.webp";